import { Gender } from 'enums'
import { z } from 'zod'

const CVStepPersonalInformationSchema = z.object({
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  phone: z.string(),
  dateOfBirth: z.string(),
  country: z.string(),
  city: z.string(),
  drivingLicence: z.boolean(),
  openToRelocation: z.boolean(),
  gender: z.nativeEnum(Gender),
  contactInformation: z.string().email()
})

export default CVStepPersonalInformationSchema
